import { alpha, Button, Card, Container, Grid, Stack, styled, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PATH_PAGE } from '../../routes/paths';
import TextMaxLine from '../../components/TextMaxLine';
import { MotionViewport, varFade } from '../../components/animate';
import { m } from 'framer-motion';

const Data = [
  {
    title: 'Un accès régionnal stratégique',
    image: '/assets/background/Emplacement_stratégique.jpg',
  },
  { title: 'Des infrastructures logistiques majeures', image: '/assets/background/Secteurs_prometteurs.jpg' },
  {
    title: 'Des secteurs à fort potentiel',
    image: '/assets/background/Environement_des_affaires.jpg',
  },
];

const RootStyle = styled(Stack)(() => ({
  width: '100%',
  position: 'relative',
  backgroundColor: alpha('#E3E4E6', 0.4),
}));

const CardStyle = styled(Card)(({ url }) => ({
  border: 0,
  maxWidth: 320,
  minHeight: 360,
  maxHeight: 360,
  margin: 'auto',
  backgroundImage: `url(${url})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

const TextBackground = styled(Stack)(() => ({
  border: 0,
  width: '100%',
  height: '120px',
  backgroundColor: '#000',
}));

const ButtonStyle = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  borderWidth: 2,
  borderStyle: 'solid',
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(1.5, 4),
  fontWeight: 600,
  fontSize: '1rem',
  textTransform: 'none',
  '&:hover': {
    color: '#fff',
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function HomeInvestTogo() {
  const navigate = useNavigate();
  return (
    <RootStyle py={5} alignItems="center">
      <Container>
        <Stack alignItems="center" spacing={{ xs: 1, md: 5 }}>
          <Typography align="center" variant="h2">
          Pourquoi investir au Togo ? 
          </Typography>

          <Stack component={MotionViewport} direction={{ xs: 'column', md: 'row' }} py={{ xs: 2, md: 5 }}>
            <Grid container spacing={{ xs: 2, sm: 3, md: 5 }} justifyContent="center" alignItems="center">
              {Data.map((item) => (
                <Grid component={m.div} variants={varFade().inUp} key={item.title} item xs={12} sm={6} md={4}>
                  <CardItem
                    title={item.title}
                    image={item.image}
                    onClick={() => navigate(PATH_PAGE.investire_au_togo.r10_d_investir_au_togo)}
                  />
                </Grid>
              ))}
            </Grid>
          </Stack>
          <Stack alignItems="center">
            <ButtonStyle onClick={() => navigate(PATH_PAGE.investire_au_togo.r10_d_investir_au_togo)} sx={{ px: 5 }}>
              Découvrir les atouts du Togo
            </ButtonStyle>
          </Stack>
        </Stack>
      </Container>
    </RootStyle>
  );
}

const CardItem = ({ title, image, onClick }) => {
  const [hover, setHover] = React.useState(false);

  return (
    <CardStyle
      onClick={onClick}
      url={image}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{ maxWidth: { xs: 1, md: 320 } }}
    >
      <Stack height={360} justifyContent="flex-end">
        <Stack
          height={hover ? 360 : 100}
          justifySelf="flex-end"
          justifyContent="space-between"
          sx={{ cursor: 'pointer', transition: 'height 0.8s ease-in-out' }}
        >
          <TextBackground p={2} spacing={2}>
            <TextMaxLine line={3} variant="h4" textAlign="center" fontSize={13} color="common.white" fontWeight="bold">
              {title}
            </TextMaxLine>
          </TextBackground>
        </Stack>
      </Stack>
    </CardStyle>
  );
};
